import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "w-100" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-12" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Tenant References")
const _hoisted_5 = {
  key: 0,
  class: "d-flex flex-column gap-5"
}
const _hoisted_6 = { class: "w-100 bg-white p-5" }
const _hoisted_7 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_8 = { class: "text-capitalize" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "text-capitalize" }
const _hoisted_11 = { class: "d-flex align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_TenantHeaderDetails = _resolveComponent("TenantHeaderDetails")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_el_rate = _resolveComponent("el-rate")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Breadcrumb, { items: _ctx.breadcrumbs }, null, 8, ["items"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.tenantDetails)
          ? (_openBlock(), _createBlock(_component_TenantHeaderDetails, {
              key: 0,
              info: _ctx.tenantDetails
            }, null, 8, ["info"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_Card, { style: {"margin-top":"35px","margin-bottom":"50px"} }, {
      title: _withCtx(() => [
        _hoisted_4
      ]),
      default: _withCtx(() => [
        (!_ctx.table.items.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_el_skeleton, {
                  animated: "",
                  row: "5"
                })
              ])
            ]))
          : (_openBlock(), _createBlock(_component_DataTable, {
              key: 1,
              "table-data": _ctx.table.items,
              "table-header": _ctx.tableHeaders,
              "onClick:row": _ctx.viewReference,
              "row-class": "table-hover"
            }, {
              "cell-agency": _withCtx(({ row: item }) => [
                (item.user.business_name)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createElementVNode("span", _hoisted_8, _toDisplayString(item.user.business_name), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_9, "Not Specified"))
              ]),
              "cell-agent_name": _withCtx(({ row: item }) => [
                _createElementVNode("span", _hoisted_10, _toDisplayString(item.user.first_name) + " " + _toDisplayString(item.user.last_name), 1)
              ]),
              "cell-date": _withCtx(({ row: item }) => [
                _createTextVNode(_toDisplayString(_ctx.$filters.formatDate(item.date, 'aus')), 1)
              ]),
              "cell-rating": _withCtx(({ row: item }) => [
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_el_form_item, { class: "mb-0" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_rate, {
                        class: "rating-size",
                        "model-value": 1,
                        disabled: "",
                        max: "1"
                      })
                    ]),
                    _: 1
                  }),
                  _createTextVNode(" " + _toDisplayString(parseFloat(item.average_rating).toFixed(1)), 1)
                ])
              ]),
              _: 1
            }, 8, ["table-data", "table-header", "onClick:row"]))
      ]),
      _: 1
    })
  ]))
}